import { CommentOutlined } from '@ant-design/icons';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { GuuruOutlined } from '@guuru/react-icon';

const menuItems = [
  {
    key: 'chats',
    space: 'chat',
    icon: <CommentOutlined />,
  },
  {
    key: 'home',
    paths: ['guurus'],
    space: 'community',
    icon: <GuuruOutlined />,
  },
];

const useMenuItems = (spaces: string[]) => {
  const { pathname } = useLocation();
  const { t } = useTranslation();

  const selectedKey = useMemo(
    () =>
      menuItems.find(
        ({ key, paths }) =>
          pathname.includes(key) ||
          paths?.find((path) => pathname.includes(path)),
      )?.key || 'chats',
    [pathname],
  );

  const mainMenuItems = spaces.map((id) => ({
    ...menuItems.find(({ space }) => space === id)!,
    label: t(`chat:::${id}SpaceLabel`),
  }));

  return { selectedKey, mainMenuItems };
};

export default useMenuItems;
